









































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CashProjectVue from "./CashProject.vue";
import version from "@/version";
 
import { mapGetters } from "vuex";
@Component({
    components: {
        "cash-project": CashProjectVue
    }
})
export default class CashDetailed extends Vue {
    @Prop({ type: String })
    endPeriod?: string;

    mingxiData: CashDetailedList.CashDetailedList[] = [];

    mounted() {
        this.fetchData();
    }
        // 下载
        downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/cashflow/detail?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.endPeriod}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }    
    // 获取表格数据
    fetchData() {
        if (this.endPeriod) {
            Vue.axios
                .post(`cashdetail/find`, {
                    accountBookId: this.$store.state.accountBook.id,
                    endPeriod: this.endPeriod
                })
                .then(res => {
                    this.mingxiData = res.data.cashList;
                });
        }
    }

    // 项目弹窗
    isCashProject: boolean = false;
    detailId: number = 0;
    cashProjectShow(id: number) {
        this.detailId = id;
        this.isCashProject = true;
    }
    closeCashProject() {
        this.isCashProject = false;
    }
    cashProjectSuccess() {
        this.fetchData();
        this.isCashProject = false;
    }
}
